// Types
import { Driver } from "@/types/supabase";

// Components
import { Card, CardTitle } from "@/components/atoms/card";

// Icons
import { Battery, Smartphone } from "lucide-react";

interface DeviceInfoCardProps {
  driver: Driver;
  realTimeData: any;
}

export function DeviceInfoCard({ driver, realTimeData }: DeviceInfoCardProps) {
  return (
    <>
      <Card className="py-3 px-4 flex flex-row items-center bg-white gap-3">
        <span className="inline-flex items-center justify-center h-8 w-8 rounded-xl bg-gray-50 ring-1 ring-gray-100">
          <Smartphone className="w-5 h-5 text-gray-400" />
        </span>
        <div>
          <CardTitle className="text-base font-medium text-gray-900 mb-0">
            Dispositivo
          </CardTitle>
          <div className="text-sm text-gray-600 font-normal">
            Información y estado del dispositivo
          </div>
        </div>
      </Card>
      <Card className="bg-white p-8">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex flex-col flex-1 gap-6">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-2">
                Marca del dispositivo
              </label>
              <div className="text-sm text-gray-900 font-medium">
                {driver?.device_info?.brand || "No especificada"}
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-2">
                Modelo
              </label>
              <div className="text-sm text-gray-900 font-medium">
                {driver?.device_info?.model || "No especificado"}
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-2">
                Versión de aplicación
              </label>
              <div className="text-sm text-gray-900 font-medium">
                {driver?.device_info?.app_version || "No especificada"}
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1 border border-gray-200 rounded-xl p-5 gap-2">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Estado del dispositivo
            </p>
            <div className="flex items-center gap-2 pb-2 px-2 border-b border-gray-200">
              <span
                className={`h-2 w-2 rounded-full ${
                  realTimeData ? "bg-green-500" : "bg-red-500"
                } inline-block`}
              />
              <span className="text-sm font-medium">
                {realTimeData ? "Conectado" : "Desconectado"}
              </span>
            </div>
            <div className="flex items-center gap-2 border-b border-gray-200 pb-2 px-2">
              <Battery className="w-5 h-5 text-gray-600" />
              <span
                className={`${
                  driver?.device_info?.battery_level
                    ? driver.device_info.battery_level > 50
                      ? "text-green-600"
                      : "text-red-600"
                    : "text-gray-600"
                } font-medium`}
              >
                {driver?.device_info?.battery_level
                  ? `${driver.device_info.battery_level}%`
                  : "Sin datos"}
              </span>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
